var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkermap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.721,
    height: 70.09,
    viewBox: "0 0 63.721 99.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "063qwyc1xa",
    x: 0,
    y: 33.364,
    width: 63.721,
    height: 65.726,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23581"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#063qwyc1xa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7589",
    d: "M-370.951 251.4a22.727 22.727 0 0 0-2.313 9.971c0 12.625 22.86 37.755 22.86 37.755s22.861-25.129 22.861-37.755a22.725 22.725 0 0 0-2.314-9.971c-5.3 1.952-12.6 3.079-20.547 3.079s-15.248-1.13-20.547-3.079zm27.514 12.771a6.967 6.967 0 0 1-6.967 6.967 6.967 6.967 0 0 1-6.967-6.967 6.967 6.967 0 0 1 6.971-6.971 6.967 6.967 0 0 1 6.962 6.968z",
    transform: "translate(382.255 -212.03)",
    style: {
      fill: "#612166"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7590",
    d: "m-372.355 234.574 1.375-.507c5.393-1.989 12.714-3.084 20.611-3.084s15.218 1.1 20.612 3.084l1.375.507.48 1.384.541 1.564c3.359-2.314 6.039-4.927 6.278-8.6-.323-4.972-5.106-8.005-10-10.974-5.216-2.788-10.546-5.511-19.281-5.694-8.734.183-14.065 2.905-19.281 5.694-4.9 2.969-9.682 6-10 10.974.238 3.675 2.919 6.289 6.277 8.6l.542-1.563z",
    transform: "translate(382.228 -212.251)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7591",
    d: "M-373.443 246.951c4.485 2.7 13.12 4.526 23.04 4.526s18.556-1.828 23.041-4.526l-3.5-10.1c-4.816-1.777-11.785-2.893-19.541-2.893s-14.724 1.116-19.54 2.893z",
    transform: "translate(382.263 -212.13)",
    style: {
      fill: "#612166"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkermap);
export default __webpack_public_path__ + "static/media/markermap.e35e7f09a0081bda2db98f0c5d63ddb0.svg";
export { ForwardRef as ReactComponent };